<template>
	<div id="app" style="height:100vh;width:100vw;overflow:hidden;position:fixed;">
		<router-view/>
	</div>
</template>
<script>
import Navbar from './components/Navbar'

export default {
	name: 'App',
	components: {
		Navbar
	},
	sockets: {
		connect: function () {
			console.log('socket connected')
			// window.webkit.messageHandlers["maintenance"].postMessage({ "maintenance": "true"})
		},
		customEmit: function (data) {
			console.log(
				'this method was fired by the socket server. eg: io.emit("customEmit", data)'
			)
		}
	},
	data () {
		return {
			spinner: {
				status: true
			}
		}
	},
	mounted () {
		console.log(this.$moment.locale())
		this.$moment.locale('de')
		console.log(this.$moment.locale())
	}
}
</script>
<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";
// Set your colors
$primary: #8c67ef;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);
$black: #000000;
$text: #000;
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
	"white": (
		$white,
		$black
	),
	"black": (
		$black,
		$white
	),
	"light": (
		$light,
		$light-invert
	),
	"dark": (
		$dark,
		$dark-invert
	),
	"primary": (
		$primary,
		$primary-invert
	),
	"info": (
		$info,
		$info-invert
	),
	"success": (
		$success,
		$success-invert
	),
	"warning": (
		$warning,
		$warning-invert
	),
	"danger": (
		$danger,
		$danger-invert
	),
	"twitter": (
		$twitter,
		$twitter-invert
	)
);
// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;
// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
@media screen and (min-width: $tablet), print {
	.navbar > .container {
		padding: 1.5rem 0rem; // padding-bottom: 3.5rem;
	}
}

html {
	background: #fff6d9;
}

.company-info {
	margin: 2em 1em;
}
.footer {
	margin-top: 8em;
	color: #000;
	padding-bottom: 4em;
}

#app {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale; // text-align: center;
	// color: #2c3e50;
	margin-top: 0px;
}

.is-vertical-center {
	display: flex;
	align-items: center;
}

.full-height {
	height: 100vh;
}
.full-width {
	width: 100%;
}
.button {
	font-size: 2.7em;
	font-family: "Avenir Next";
	background: #d63031;
	border: 0;
	color: #fff !important;
	font-weight: 600;
	padding: 0.5em 1.5em 0.4em 1.5em;
	height: auto;
	margin: 0.5em;
	display: inline-block;
	border-radius: 5px;
}

.smaller-heading {
	font-size: 3em;
	font-weight: 900;
	text-align: center;
}
.text {
	font-size: 1.5em;
	text-align: center;
margin: 2em;
    margin-top: 0.5em;

}
.back-button {
	position: absolute;
	bottom: 2em;
	left: 2em;
}
.next-button {
	position: absolute;
	bottom: 2em;
	right: 2em;
}
.back-button button,
.next-button button {
	font-size: 2.2em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue